import { api } from '../../api';
import { TopOrderSystemAlertsRequest } from '../../model/reporting/topOrderSystemAlertsRequest';

export const reportingService = {
  getTopOrderSystemAlerts,
};

function getTopOrderSystemAlerts(request: TopOrderSystemAlertsRequest) {
  return api.post('/reporting/system-alerts/latest', request);
}
